"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScreenSize = void 0;

var _useWindowDimensionsContext = require("./useWindowDimensionsContext");

var _useBreakpoint = require("./useBreakpoint");

var useScreenSize = function useScreenSize() {
  var _useWindowDimensionsC = (0, _useWindowDimensionsContext.useWindowDimensionsContext)(),
      width = _useWindowDimensionsC.width;

  return (0, _useBreakpoint.useBreakpoint)(width);
};

exports.useScreenSize = useScreenSize;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/hooks/useScreenSize.js
// module id = 879
// module chunks = 209 210 211 212